module.exports = __webpack_public_path__ + "img/stick_restauration_producteurs.acd3c94e.svg";